<div class="c-page-policy">
    <div class="container u-pb30">
        <div class="row mobile--orange u-pt40">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a [routerLink]="['/']">{{'PolicyChangeRequestPortal.home'| translate}}</a></li>
                        <li class="breadcrumb-item active" aria-current="page">&nbsp;-<span>  {{'PolicyChangeRequestPortal.location' | translate}} </span></li>
                    </ol>
                </nav>
                <h2 class="o-title"> {{ 'PolicyChangeRequestPortal.title' | translate}}</h2>
                <div class="mobile--orange__cont">
                    <p class="o-text o-text--description"> {{ 'PolicyChangeRequestPortal.subtitle1' | translate}} :</p>
                    <div class="mobile--orange__height" *ngFor="let type of types">
                        <p class="o-text o-text--description" *ngIf="getlang()==='en'" >· <strong > {{type.name}} : </strong><span>{{type.description}} </span></p>
                        <p class="o-text o-text--description" *ngIf="getlang()==='es'" >· <strong > {{type.nameEs}} : </strong><span>{{type.descriptionEs}} </span></p>
                    </div>
                    <p class="o-text o-text--description">{{ 'PolicyChangeRequestPortal.subtitle2' | translate}}</p>
                </div>
               
            </div>
        </div>

        <form class="o-form" [formGroup]="formPolicy" (ngSubmit)="onSubmit()">
            <div class="row u-pt40">
                <div class="col-md-12" id='RequestDetail'>
                    <h2 class="o-title o-title--medium o-title--orange">{{ 'PolicyChangeRequestPortal.titleRequestDetails' | translate}}</h2>
                    <p class="o-text">{{ 'PolicyChangeRequestPortal.requiredInfo' | translate}}</p>
                </div>
            </div>
            <div class="row ">
                <div class="col-md-6 u-pt30 ">
                    <div class="form-group ">
                        <label class="o-title o-title--label o-title--required">{{ 'PolicyChangeRequestPortal.siteImpactChange' | translate}}</label>

                <!-- validation Combo Box-->
                    
            
                        <select name="siteId" formControlName="siteId" class="o-form__select" required style="cursor:pointer">
                            <option [value]="''" disabled >{{ 'PolicyChangeRequestPortal.selOption' | translate}}</option>
                            <option [value]="op.id" *ngFor="let op of sites" >{{op.name}}</option>
                        </select>
                        <div *ngIf="formPolicy.controls['siteId'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9">
                            <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i>{{ 'PolicyChangeRequestPortal.fieldRequired' | translate}}</mat-error></h5></span>
                        </div>

                    </div>

                </div>
            </div>


            <!--    -------------------------------     types  --------------------------------- -->

            <div class="row">
                
                <div id="radio-type" class="col-md-7 u-pt40 u-pb20">
                    <label class="o-title o-title--label o-title--required" >{{'PolicyChangeRequestPortal.typesModify'| translate}}</label><br>    
                    <div *ngFor="let type of types; let i=index" class="col-md-12">
                        <div class="col-md-3">
                            <label >
                                <input  type="checkbox" [value]="type.id" (change)="onCheckChange($event)" >
                                        <label *ngIf="getlang()==='en'" style="padding-left: 5px;">{{type.name | titlecase}}</label> 
                                        <label *ngIf="getlang()==='es'" style="padding-left: 5px;">{{type.nameEs | titlecase}} </label>
                            </label>
                            <!-- <label *ngIf="getlang()==='es'">
                                <input  type="checkbox" [value]="type.id" (change)="onCheckChange($event)" >
                                        {{type.nameEs}} 
                            </label> -->
                        </div>
                        <div class="col-md-1">
                            <span *ngIf="getlang()==='en'" class="u-hide__desktop ptooltip title--tooltip"  matTooltipPosition="right" matTooltip="{{type.description}}." >
                                ?
                            </span>
                            <span *ngIf="getlang()==='es'" class="u-hide__desktop ptooltip title--tooltip"  matTooltipPosition="right" matTooltip="{{type.descriptionEs}}." >
                                ?
                            </span>
                        </div>
                        
                    </div>
                    

                </div>
               
            </div>
             <div *ngIf="typesCheck" style="width:100%; background-color: #F2F0E9" align="center">
                <span><h5 style="padding: 15px;"><mat-error style=" white-space: normal; "><i class="icon icon-close"></i> 
                    {{ 'PolicyChangeRequestPortal.fieldRequired' | translate}}</mat-error></h5></span>
            </div> 
            <!--    ----------------------------------END aspecs-------------------------------------------       -->
            <hr class="big">
            <div class="row u-pt20">
                <div class="col-md-12">
                    <h2 class="o-title o-title--medium o-title--orange">{{ 'PolicyChangeRequestPortal.changeInfo' | translate}}</h2>
                    <p class="o-text">{{ 'PolicyChangeRequestPortal.forModify' | translate}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 u-pt30">
                    <h2 class="o-title o-title--medium">{{ 'PolicyChangeRequestPortal.documentChange' | translate}}</h2>
                    <p class="o-text">{{ 'PolicyChangeRequestPortal.downloadExcel' | translate}}</p>
                    <div class="custom-file">
                        <div class="custom-file-text" style="padding-bottom: 10px;">
                            <div class="custom-file-text-cont" type="file" *ngIf="fileName=='false'" name="fileUpload">
                                <i class="icon icon-clip"> </i>
                                <p>{{ 'PolicyChangeRequestPortal.attachExcel' | translate}}</p>

                            </div>
                            <div class="custom-file-text-cont" type="file" *ngIf="fileName !== 'false'">
                                <i class="icon icon-check"> </i>

                                <p> {{ fileName }}</p>
                            </div>
                            
                        </div>
                        <div *ngIf="submited && (!file) && (!(filesize || fileformat))" style="width:100%; background-color: #F2F0E9" class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-2">
                            <h5 style="padding: 15px;"><i class="icon icon-close"></i>
                                <mat-error style=" white-space: normal;"> {{ 'PolicyChangeRequestPortal.msgUploadfile' | translate}}</mat-error>
                            </h5>

                        </div>
                        <div *ngIf="fileformat" style="width:100%; background-color: #F2F0E9" class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-2">
                            <h5 style="padding: 15px;"><i class="icon icon-close"></i>
                                <mat-error style=" white-space: normal;"> {{ 'PolicyChangeRequestPortal.invalidFormat' | translate}}.</mat-error>
                            </h5>

                        </div>
                        <div *ngIf="filesize" style="width:100%; background-color: #F2F0E9" class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-2">
                            <h5 style="padding: 15px;"><i class="icon icon-close"></i>
                                <mat-error style=" white-space: normal;"> {{ 'PolicyChangeRequestPortal.maxSizeExcel' | translate}}</mat-error>
                            </h5>

                        </div>

                        <div class="custom-file-input">
                            <input class="custom-file-input attach_document" id="customFile" type="file" data-msg="Volver a subir archivo" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" (change)="detectFiles($event)">
                            <span *ngIf="fileName !== 'false'"> {{ 'PolicyChangeRequestPortal.uploadFileAgain' | translate}} </span>
                            <span *ngIf="fileName == 'false'"> {{ 'PolicyChangeRequestPortal.uploadFile' | translate}}</span>
                        </div>
                        <div class="custom-file_extend">
                            <a style=" cursor: pointer; " *ngIf="getlang()==='en'" download="Policy_Change_Management_Document_EN.xlsx" target="_blank" href="/assets/Policy_Change_Management_Document_EN.xlsx"> 
                                
                                <span>{{ 'PolicyChangeRequestPortal.template' | translate}}</span>
                            </a>
                            <a style=" cursor: pointer; " *ngIf="getlang()==='es'" download="Policy_Change_Management_Document_ES.xlsx" target="_blank" href="/assets/Policy_Change_Management_Document_ES.xlsx"> 
                                
                                <span>{{ 'PolicyChangeRequestPortal.template' | translate}} </span>
                            </a>
                            <i hidden class="icon icon-link"></i>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 u-pt60">
                    <div class="form-group">
                        <label class="o-title o-title--label">{{ 'PolicyChangeRequestPortal.labelComments' | translate}}</label>
                        <textarea class="o-form__textarea" placeholder="{{ 'PolicyChangeRequestPortal.placeholderComments' | translate}}" formControlName="commentary" name="commentary"></textarea>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 u-pt20">
                    <div class="o-form__checkbox u-mb20">
                        <input type="checkbox" value="value" formControlName="Confirm" name="Confirm" required><span></span>
                        <a class="open_modal" (click)="openDialog()" data="terms" style="cursor:pointer">{{'PolicyChangeRequestPortal.confirm' | translate}}</a>
                    </div>
                    <div align="center" *ngIf="formPolicy.controls['Confirm'].hasError('required') && submited" style="width:100%; background-color: #F2F0E9" class="col-md-12 col-xs-12 col-md-offset-0 col-xs-offset-2">
                        <h5 style="padding: 15px;"><i class="icon icon-close"></i>
                            <mat-error style=" white-space: normal;"> {{ 'PolicyChangeRequestPortal.confirmterms' | translate}}</mat-error>
                        </h5>
                    </div>

                    <br>
                </div>
                <div class="col-md-12" style="padding-top: 20px;">
                    <button class="btn btn--primary">{{'PolicyChangeRequestPortal.btnGenerate' | translate}}</button>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- 

<div class="o-modal o-modal--big" id="terms">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal"></a>
        <label class="o-title o-title--white o-title--medium js-text-modal-1">{{'modals-mod-terms.title' | translate}}</label>
    </div>
    <div class="o-modal__body o-modal__body--no_gutter">
        <div class="js-scrolling">
            <div class="o-modal__text">
                <div class="o-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis odio vitae sapiente architecto fugit repudiandae nulla eveniet quia alias reprehenderit natus, nostrum dolores molestias quam suscipit laborum deserunt ratione in!</div>
                <ul class="o-modal__list">
                    <li>Lorem ipsum dolor.</li>
                    <li>Lorem ipsum dolor.</li>
                    <li>Lorem ipsum dolor.</li>
                </ul>
                <div class="o-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis odio vitae sapiente architecto fugit repudiandae nulla eveniet quia alias reprehenderit natus, nostrum dolores molestias quam suscipit laborum deserunt ratione in!</div>
                <div class="o-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis odio vitae sapiente architecto fugit repudiandae nulla eveniet quia alias reprehenderit natus, nostrum dolores molestias quam suscipit laborum deserunt ratione in!</div>
                <div class="o-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis odio vitae sapiente architecto fugit repudiandae nulla eveniet quia alias reprehenderit natus, nostrum dolores molestias quam suscipit laborum deserunt ratione in!</div>
                <div class="o-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis odio vitae sapiente architecto fugit repudiandae nulla eveniet quia alias reprehenderit natus, nostrum dolores molestias quam suscipit laborum deserunt ratione in!</div>
                <div class="o-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis odio vitae sapiente architecto fugit repudiandae nulla eveniet quia alias reprehenderit natus, nostrum dolores molestias quam suscipit laborum deserunt ratione in!</div>
                <div class="o-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis odio vitae sapiente architecto fugit repudiandae nulla eveniet quia alias reprehenderit natus, nostrum dolores molestias quam suscipit laborum deserunt ratione in!</div>
                <div class="o-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis odio vitae sapiente architecto fugit repudiandae nulla eveniet quia alias reprehenderit natus, nostrum dolores molestias quam suscipit laborum deserunt ratione in!</div>
            </div>
        </div>
    </div>
    <div class="o-modal__footer">
        <div>
            <button class="btn btn--default js-text-modal-2">{{'buttons.cancel' | translate}}</button>
            <button class="btn btn--primary js-text-modal-3">{{'buttons.generate' | translate}}</button>
        </div>
    </div>
</div>
<div class="o-modal" id="modal">
    <div class="o-modal__head">
        <a class="o-modal__close close-modal"></a>
        <label class="o-title o-title--white o-title--medium">{{'options.confirm' | translate}}</label>
    </div>
    <div class="o-modal__body">
        <div class="o-modal__text">
            <div class="o-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Corporis odio vitae sapiente architecto fugit repudiandae nulla eveniet quia alias reprehenderit natus, nostrum dolores molestias quam suscipit laborum deserunt ratione in!</div>
            <ul class="o-modal__list">
                <li>Lorem ipsum dolor.</li>
                <li>Lorem ipsum dolor.</li>
                <li>Lorem ipsum dolor.</li>
            </ul>
        </div>
    </div>
    <div class="o-modal__footer">
        <div class="form-group row">
            <button class="btn btn--secundary">{{'buttons.cancel' | translate}}</button>

            <button [disabled]="formPolicy.pristine" class="btn btn--primary"> {{'buttons.generate' | translate}} </button>
        </div>
    </div>
</div> -->